(function(){
  var root = document.getElementById('seikom-batt-lp');
  if(!root) return;

  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');

  if(!mq.matches && 'IntersectionObserver' in window){
    var targets = root.querySelectorAll('.sec-head, .cascade, .sol-grid, .range-grid, .loc-grid, .praxis-lg, .marking .grid, .res-grid');
    targets.forEach(function(el){ el.classList.add('reveal'); });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, {threshold: .12, rootMargin: '0px 0px -8% 0px'});
    targets.forEach(function(el){ io.observe(el); });
    // safety: never leave content hidden if the observer never fires
    setTimeout(function(){
      root.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
    }, 1400);
  }

  var num = root.querySelector('#ro-num-batt');
  if(num && !mq.matches){
    var lang = root.getAttribute('data-lang');
    var locale = lang === 'en' ? 'en-US' : lang === 'fr' ? 'fr-FR' : lang === 'it' ? 'it-IT' : 'de-DE';
    setInterval(function(){
      var v = 3380 + Math.floor(Math.random() * 180);
      num.textContent = v.toLocaleString(locale);
    }, 1700);
  }
})();
